const ItemGenerator = require('../../../game_items/ItemGenerator.js');
var MedTorsoe = require('../../../game_items/equipment/torsoe/MedTorsoe.js');
var MedBoots = require('../../../game_items/equipment/boots/MedBoots.js');
var Dagger = require('../../../game_items/equipment/weapon/Dagger.js');
var Bow = require('../../../game_items/equipment/off_hand/Bow.js');
const getMobEquipmenAssignmentFromBags = require('./getMobEquipmenAssignmentFromBags');

const bandit = (level) => {
  const handle = 'bandit';
  const types = ['archer', 'humanoid', 'archer'];
  const AI_PRIORITIES = ['interference', 'dps_ranged', 'dps_close', 'tank', 'support'];
  const bags = [
    {
      items: [
        ItemGenerator.getCavernsMobItem(MedTorsoe, level),
        ItemGenerator.getCavernsMobItem(MedBoots, level),
        ItemGenerator.getCavernsMobItem(Dagger, level),
        ItemGenerator.getCavernsMobItem(Bow, level),
      ].map((item) => ({ value: item })),
    },
  ];
  const equipped_abilities = [
    { value: 'move' },
    { value: 'melee_attack' },
    { value: 'arrow_shot' },
    { value: 'razor_shot' },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'bandit_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          arrow_shot: {
            handle: 'arrow_shot',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          razor_shot: {
            handle: 'razor_shot',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          range: {
            handle: 'range',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(4 + bound_level * 0.35 + Math.random() * 3),
      perception: Math.round(6 + bound_level * 0.85 + Math.random() * 3),
      mana: Math.round(3 + bound_level * 0.3 + Math.random() * 3),
      toughness: Math.round(5 + bound_level * 0.7 + Math.random() * 3),
      strength: Math.round(5 + bound_level * 0.75 + Math.random() * 3),
      willpower: Math.round(4 + bound_level * 0.4 + Math.random() * 3),
      dexterity: Math.round(6 + bound_level * 0.85 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 350,
    drops_gold: true,
    drops_equipment: true,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities,
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = bandit;
